import { render, staticRenderFns } from "./LayoutContentHorizontalNav.vue?vue&type=template&id=38d50520&scoped=true"
import script from "./LayoutContentHorizontalNav.vue?vue&type=script&lang=js"
export * from "./LayoutContentHorizontalNav.vue?vue&type=script&lang=js"
import style0 from "./LayoutContentHorizontalNav.vue?vue&type=style&index=0&id=38d50520&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38d50520",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VOverlay } from 'vuetify/lib/components/VOverlay';
installComponents(component, {VOverlay})
